/* French-language fallback for the existing Navidium cart widget.
 * Navidium supplies its own content; translate only known English display text.
 * Preserve markup, prices, input/toggle elements, and event handlers.
 * Match the buyer's storefront language, never the buyer's province.
 */
(() => {
  if (!/^fr(?:-|$)/i.test(document.documentElement.lang || '')) return;

  const substitutions = [
    [/\bSHIPPING PROTECTION\b/g, "PROTECTION D'EXPÉDITION"],
    [/\bShipping Protection\b/g, "Protection d'expédition"],
    [/\bfrom Damage, Loss\s*(?:&|and)\s*Theft for\b/gi, "contre les dommages, la perte et le vol, pour"],
    [/Get peace of mind with Delivery Guarantee in the event your delivery is damaged,\s*stolen,?\s*or lost during transit\.?/gi,
      "Profitez d'une tranquillité d'esprit grâce à une protection en cas de perte, de vol ou de dommages durant le transport."],
    [/^\s*Learn more\s*$/i, 'En savoir plus']
  ];
  let scheduled = false;

  function translateWidget() {
    scheduled = false;
    document.querySelectorAll('.nvd-mini').forEach(widget => {
      const walker = document.createTreeWalker(widget, NodeFilter.SHOW_TEXT);
      const pending = [];
      while (walker.nextNode()) {
        const node = walker.currentNode;
        if (!node.nodeValue || !node.nodeValue.trim()) continue;
        const parent = node.parentElement;
        if (!parent || parent.closest('script,style,noscript,svg,option,button,input,textarea')) continue;
        let value = node.nodeValue;
        for (const [expression, translation] of substitutions) value = value.replace(expression, translation);
        if (value !== node.nodeValue) pending.push([node, value]);
      }
      pending.forEach(([node, value]) => { node.nodeValue = value; });
    });
  }

  function scheduleTranslation() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(translateWidget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleTranslation, { once: true });
  } else scheduleTranslation();

  const observer = new MutationObserver(scheduleTranslation);
  observer.observe(document.body || document.documentElement, {
    subtree: true,
    childList: true,
    characterData: true
  });
})();
